import { Cookies } from 'react-cookie';

import { UsersPageDataRow } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getUsersPageData = async (table_name: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('/users/', {
    headers: {
      Authorization: token,
    },
    params: {
      table_name,
    },
  });
  return data.data as UsersPageDataRow[];
};
